'use client';

import { useState, useEffect, lazy, Suspense } from 'react';
import { ButtonIcon } from '@workspace/ui/common';
import { ALGOLIA_CONFIG } from '@workspace/lib';
import { Configure } from 'react-instantsearch';
import { InstantSearchProvider } from '@workspace/providers';

const HeaderSearchContent = lazy(() => import('./HeaderSearchContent'));

interface HeaderSearchProps {
  isMobileNav?: boolean;
  onSearchToggle?: (isOpen: boolean) => void;
}

export const HeaderSearch = ({ onSearchToggle }: HeaderSearchProps) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  // Prevent body scroll when search is open
  useEffect(() => {
    if (isSearchOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isSearchOpen]);

  const handleSearchToggle = () => {
    if (!hasInteracted) {
      setHasInteracted(true);
    }
    const newState = !isSearchOpen;
    onSearchToggle?.(newState);
    setIsSearchOpen(newState);
  };

  return (
    <InstantSearchProvider indexName={ALGOLIA_CONFIG.INSTANT_SEARCH_QUERY_SUGGESTIONS}>
      <div className="relative search-container">
        <ButtonIcon
          iconName="Search"
          onClick={handleSearchToggle}
          className="p-2 text-secondary-400 hover:text-primary-500 transition-colors duration-200 active:border-none"
          aria-label="Search"
        />

        <Configure hitsPerPage={3} />
        {hasInteracted && (
          <Suspense fallback={<div className="fixed inset-0 z-9999 bg-white" />}>
            <HeaderSearchContent isSearchOpen={isSearchOpen} setSearchOpen={setIsSearchOpen} />
          </Suspense>
        )}
      </div>
    </InstantSearchProvider>
  );
};
